import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { accessService } from '../../services/central-api/access';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    actingBodyId?: number;
    zIndex: number;
    required?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function RolesDropdown({ value, setValue, zIndex, actingBodyId, required, form, fieldName }: Props) {
    const [selectableRoles, setSelectableRoles] = useState<{ label: string; value: number; }[]>([]);

    async function loadRolesAndUnits(actingBodyId: number) {
        try {
            const actingBody = await accessService.getActingBody(actingBodyId);
            if (!actingBody.roles) {
                setSelectableRoles([]);
            } else {
                setSelectableRoles(actingBody.roles.map((role) => {
                    return {
                        value: role.id || 0,
                        label: role.name
                    };
                }));
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId && actingBodyId > 0) {
            loadRolesAndUnits(actingBodyId);
        }
    }, [actingBodyId]);


    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('role')}
            items={selectableRoles}
            multiple={false}
            zIndex={zIndex}
            required={required}
            fieldName={fieldName}
            form={form}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('role')}
                items={selectableRoles}
                multiple={false}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                required={required}
            />
        );
    }
}

export default RolesDropdown;
